import React from 'react';
import { useScreenings } from 'queries/screenings';
import { LoadingBox } from '@hubins/components/LoadingIndicators';
import ExpandableContent from '@hubins/components/ExpandableContent';
import { formatDate } from 'helpers';
import ScreeningModal from './ScreeningModal';
import PepTemplate from './PepTemplate';
import SanctionsTemplate from './SanctionsTemplate';
import CompanyRisksTemplate from './CompanyRisksTemplate';
import CompanyPepTemplate from './CompanyPepTemplate';

const ScreeningContent = ({ screening }) => {
  switch (screening.type) {
    case 'pep':
      return <PepTemplate screening={screening} />
    case 'sanctions':
      return <SanctionsTemplate screening={screening} />
    case 'company-risks':
      return <CompanyRisksTemplate screening={screening} />
    case 'company-pep':
      return <CompanyPepTemplate screening={screening} />
    default:
      return (
      <pre className='s-top-l'>{JSON.stringify(screening.result, null, 2)}</pre>
    )
  }
}

const Screening = ({ client }) => {

  const { data: screenings, isLoading, refetch } = useScreenings(client.uuid);
  const isCompany = client.type === 'COMPANY';

  return (
    <>
      <ScreeningModal client={client} refetch={refetch} />
      {isLoading ? (
        <LoadingBox />
      ) : (
        <div className='s-top-l'>
          {screenings && Array.isArray(screenings) ? screenings.map((screening) => (
            <ExpandableContent key={screening.id} label={<span className='flex-center--horizontal'>{screening?.type?.toUpperCase()}   <span className='body-small c-neutral-5 s-left-m'>{formatDate(screening.created_at, true)} - {screening.user_name}</span></span>}>
              <ScreeningContent screening={screening} />
            </ExpandableContent>
          )) : <div>No screenings available</div>}
        </div>
      )}
    </>
  )


};

export default Screening;